/**
 * @deprecated - Filters are not not tied beacon project in v1
 */
export enum FilterTypeBeacon {
  CLIENT_NAME = 'client_name',
  TITLE = 'title',
  LABEL = 'label',
  INDUSTRY = 'industry',
  REGION = 'region',
  CAPABILITY = 'capability',
  DATE_RANGE = 'date_range',
  NAME = 'name',
};

export enum FilterType {
  CLIENT_NAME = 'client_name',
  TYPE = 'type',
  INDUSTRY = 'industry',
  PRACTICE = 'practice',
  NAME = 'name',
  FAVORITE = 'favorite',
  CAPABILITY = 'capability',
  OWNER = 'owner',
};

interface IFilterObjConst {
  label: string;
  operator: string;
  icon?: string;
  autoCompleteKeyword?: string;
  filterKeyword?: string;
}

/**
 * @deprecated - Filters are not not tied beacon project in v1
 */
export const FilterObjBeacon: Record<string, IFilterObjConst> = {
  [FilterTypeBeacon.CLIENT_NAME]: {
    label: 'Client Name',
    operator: 'contains',
    autoCompleteKeyword: 'project.client_company.company_name'
  },
  [FilterTypeBeacon.TITLE]: {
    label: 'Position Title',
    operator: 'contains',
    autoCompleteKeyword: 'project.title'
  },
  [FilterTypeBeacon.LABEL]: {
    label: 'Project Label',
    operator: 'contains',
    autoCompleteKeyword: 'project.label'
  },
  [FilterTypeBeacon.INDUSTRY]: {
    label: 'Industry',
    operator: 'contains',
    autoCompleteKeyword: 'project.client_company.industry'
  },
  [FilterTypeBeacon.REGION]: {
    label: 'Region',
    operator: 'contains',
    autoCompleteKeyword: 'project.location_raw'
  },
  // [FilterTypeBeacon.CAPABILITY]: {
  //   label: 'Capability',
  //   operator: 'eq',
  //   keyword: 'project.capability'
  // },
  [FilterTypeBeacon.DATE_RANGE]: {
    label: 'Date Range',
    operator: 'lte',
  },
  [FilterTypeBeacon.NAME]: {
    label: 'Project Name', // Credential Name
    operator: 'eq',
  }
};

export const CredNameFilterObj: IFilterObjConst = {
  label: 'Credential Name',
  operator: 'contains',
  autoCompleteKeyword: 'name',
};

export const FilterObj: Record<string, IFilterObjConst> = {
  [FilterType.CLIENT_NAME]: {
    label: 'Company Name',
    operator: 'contains',
    icon: 'apartment',
    autoCompleteKeyword: 'project.client_company_name',
    filterKeyword: 'client_company_name',

  },
  // @deprecated - https://findemjira.atlassian.net/browse/RRINT-1839
  // [FilterType.TYPE]: {
  //   label: 'Type',
  //   operator: 'contains',
  //   icon: 'person',
  //   autoCompleteKeyword: 'project.type',
  //   filterKeyword: 'type',
  // },
  [FilterType.INDUSTRY]: {
    label: 'Industry',
    operator: 'contains',
    icon: 'label',
    autoCompleteKeyword: 'project.industry',
    filterKeyword: 'industry',
  },
  [FilterType.PRACTICE]: {
    label: 'Practice',
    operator: 'contains',
    icon: 'construction',
    autoCompleteKeyword: 'project.practice',
    filterKeyword: 'practice',
  },
  // [FilterType.NAME]: {
  //   label: 'Project Name', // Credential Name
  //   operator: 'contains',
  // },
  [FilterType.FAVORITE]: {
    label: 'Favorites',
    operator: 'eq',
    icon: 'star',
    autoCompleteKeyword: 'project.favorite_marked_by',
    filterKeyword: 'favorite_marked_by',
  },
  [FilterType.CAPABILITY]: {
    label: 'Capability',
    operator: 'contains',
    icon: 'build',
    autoCompleteKeyword: 'project.capability',
    filterKeyword: 'capability',
  },
  [FilterType.OWNER]: {
    label: 'Owner',
    operator: 'eq',
    icon: 'user',
    autoCompleteKeyword: 'uid',
    filterKeyword: 'uid',
  },
};